import axios from "axios"
import {store} from "../store"
import {router} from "../main"

export default function () {
    axios.interceptors.response.use(null, function (error) {
        // if auth error, redirect to login and set auth to false
        if (error.response.status === 401) {
            store.commit("forceLogout");
            router.push({name: "login"});
            return Promise.reject(error);
        }
    });

    /**
     * Set the auth token even if the vue auth is expired
     */
    if (store.getters.isAuth) {
        axios.interceptors.request.use(function (config) {
            config.headers.common.Authorization = `Bearer ${store.getters.authToken}`;
            return config;
        }, function (err) {
            return Promise.reject(err);
        });
    }
}
